(function(){
  if (window.__rsMobileAccountGlobalHideLoaded) return;
  window.__rsMobileAccountGlobalHideLoaded = true;
  function mobile(){ return !window.matchMedia || window.matchMedia('(max-width: 767px)').matches; }
  function norm(s){ return (s || '').replace(/\s+/g,' ').replace(/^•\s*/,'').trim(); }
  var badExact = /^(My Orders|View Profile|Edit Profile|Logout|Log out)$/i;
  var badCombo = /My Orders[\s\S]{0,80}View Profile[\s\S]{0,80}Edit Profile[\s\S]{0,80}(Logout|Log out)/i;
  function hide(el){
    if (!el || el === document.body || el === document.documentElement) return;
    el.classList.add('rs-hide-mobile-account-menu-leak');
    el.style.setProperty('display','none','important');
    el.style.setProperty('visibility','hidden','important');
    el.style.setProperty('opacity','0','important');
    el.style.setProperty('height','0','important');
    el.style.setProperty('max-height','0','important');
    el.style.setProperty('overflow','hidden','important');
    el.style.setProperty('pointer-events','none','important');
    el.style.setProperty('margin','0','important');
    el.style.setProperty('padding','0','important');
  }
  function cleanup(){
    document.querySelectorAll('.site-header .rs-mobile-account-entry').forEach(function(el){ el.remove(); });
    if (!mobile()) return;
    document.documentElement.classList.remove('customer-open');
    document.querySelectorAll('.site-header .nav-customer, .site-header .customer-links .nav-customer, .site-header .customer-links .userToggle').forEach(function(el){
      el.classList.remove('is-open'); el.classList.remove('rs-account-open');
    });

    document.querySelectorAll('.site-header #ssw-topauth ul, .site-header #ssw-topauth ol, .site-header #ssw-topauth li, .site-header .customer-links ul, .site-header .customer-links ol, .site-header .customer-links li, .site-header .column-right ul, .site-header .column-right li, .site-header a[href*=orders], .site-header a[href*=profile], .site-header a[href*=logout]').forEach(hide);

    // Last-resort scan: hide leaked account menu text in the upper-right/top area, even if plugin moved it outside header.
    var vw = window.innerWidth || document.documentElement.clientWidth || 390;
    document.querySelectorAll('a, li, ul, ol, div, span').forEach(function(el){
      if (el.closest && el.closest('.rs-hide-mobile-account-menu-leak')) return;
      var text = norm(el.innerText || el.textContent || '');
      if (!text) return;
      var rect = el.getBoundingClientRect();
      var href = (el.getAttribute && (el.getAttribute('href') || '')) || '';
      var isBadText = badExact.test(text) || badCombo.test(text);
      var isBadHref = /orders|profile|logout/i.test(href);
      var inLeakZone = (rect.top < 750 && rect.left > vw * 0.45) || (rect.top < 520 && rect.width < 260);
      if ((isBadText || isBadHref) && inLeakZone) {
        hide(el);
        var p = el.parentElement;
        if (p && /^(LI|UL|OL)$/i.test(p.tagName)) hide(p);
      }
    });
  }
  function bind(){
    cleanup();
    [100,300,700,1200,2000,3500,6000].forEach(function(ms){ setTimeout(cleanup, ms); });
    var mo = new MutationObserver(function(){ cleanup(); });
    mo.observe(document.documentElement,{childList:true,subtree:true,characterData:true});
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',bind); else bind();
  window.addEventListener('pageshow',cleanup); window.addEventListener('resize',cleanup); window.addEventListener('scroll',cleanup,{passive:true});
})();